import React from "react";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { PrintQueue } from "../drucker/components/print-queue.component";

export const DruckerauftraegePage: React.FC = () => {
	const organizationId = useCentralStore(
		(state) => state.organization?.id ?? ""
	);

	return (
		<div className="flex flex-col gap-8 p-6 max-w-6xl">
			<h1 className="text-2xl font-semibold text-gray-900">
				Druckeraufträge
			</h1>
			<PrintQueue organizationId={organizationId} />
		</div>
	);
};
